<template>
  <div class="yh-page">
    <el-card>
      <el-row slot="header" type="flex" justify="start" align="middle" class="p-3" :gutter="10">
        <el-col :span="10">
          <el-input placeholder="输入账单文件名称进行搜索..." v-model.trim="query.search"
                    @keyup.enter.native="handleSearch">
            <el-button slot="append" icon="el-icon-search" :loading="searching" @click="handleSearch">搜索</el-button>
          </el-input>
        </el-col>
        <el-col :span="24">
          <span>
            <router-link :to="{name: 'reconcilatedRecordManagement'}" >
              <el-button type="primary" size="small" icon="el-icon-back">返回</el-button>
            </router-link>
          </span>
        </el-col>
      </el-row>

      <!-- 账单文件列表 -->
      <el-table :key="0" :data="list" stripe v-loading="loading" :element-loading-text="loadingText"
                fit highlight-current-row class="w-100">
        <!-- 操作 -->
        <el-table-column align="left" label="操作" width="150px">
          <template slot-scope="scope">
            <el-tooltip effect="light" placement="top-start" content="查看对账结果">
              <el-button v-if="showView && scope.row.is_reconciled == 1" type="text"
                @click="viewReconcilatedRecord(scope.row.id, scope.row.billing_model)" >
                <i class="el-icon-view"></i>
              </el-button>
            </el-tooltip>

            <el-tooltip effect="light" placement="top-start" content="收入确认">
              <!-- <el-button v-if="showReceivable && scope.row.is_invoiced != 1" type="text"
                @click="confirmIncome(scope.row.id, scope.row.company_code)" > -->
              <el-button v-if="showReceivable" type="text"
                @click="confirmIncome(scope.row.id, scope.row.billing_model, scope.row.company_code, scope.row.branch_office_code)" >
                <i class="el-icon-notebook-1"></i>
              </el-button>
            </el-tooltip>

            <el-tooltip effect="light" placement="top-start" content="到账确认">
              <el-button v-if="showReceived" type="text"
                @click="confirmCollected(scope.row.id, scope.row.billing_model, scope.row.company_code, scope.row.branch_office_code)" >
                <i class="el-icon-money"></i>
              </el-button>
            </el-tooltip>

          </template>
        </el-table-column>

        <!-- 状态 -->
        <el-table-column align="left" label="状态">
          <template slot-scope="scope">
            <span class="badge mr-1" :class="getStatusBadge(scope.row.is_reconciled)">
            {{ scope.row.is_reconciled| parsereconciliationstatus }}
            </span>
            <span class="badge mr-1" :class="getStatusBadge(scope.row.is_invoiced)">
            {{ scope.row.is_invoiced| parseinvoicedstatus }}
            </span>
            <span class="badge mr-1" :class="getStatusBadge(scope.row.is_collected)">
            {{ scope.row.is_collected| parsepaidstatus }}
            </span>
          </template>
        </el-table-column>

        <!-- id -->
        <el-table-column align="left" label="id" width="100px">
          <template slot-scope="scope">
            <span v-if="showView"
              >{{scope.row.id}}</span>
          </template>
        </el-table-column>

        <!-- title -->
        <el-table-column align="left" label="文件名称">
          <template slot-scope="scope">
            <span  v-if="showView"
              >{{ scope.row.title }}</span>
          </template>
        </el-table-column>

        <!-- 保险公司 -->
        <el-table-column align="left" label="保险公司" width="120px">
          <template slot-scope="scope">
            <span>{{ scope.row.branch_office_name}}</span>
          </template>
        </el-table-column>

        <!-- 保费总额 -->
        <el-table-column align="left" label="保费总额" width="120px">
          <template slot-scope="scope">
            <span>{{ scope.row.total_premium | parsecurrency}}</span>
          </template>
        </el-table-column>

        <!-- 手续费总额 -->
        <el-table-column align="left" label="手续费总额" width="120px">
          <template slot-scope="scope">
            <span>{{ scope.row.adjust_commission | parsecurrency}}</span>
          </template>
        </el-table-column>

        <!-- 详单数量 -->
        <el-table-column align="left" label="详单数量" width="120px">
          <template slot-scope="scope">
            <span>{{ scope.row.total_details }}</span>
          </template>
        </el-table-column>

        <!-- 开始时间 -->
        <el-table-column align="left" label="开始时间" width="120px">
          <template slot-scope="scope">
            <span>{{ scope.row.start_time | parseTime('{y}-{m}-{d}') }}</span>
          </template>
        </el-table-column>

        <!-- 结束时间 -->
        <el-table-column align="left" label="结束时间" width="120px">
          <template slot-scope="scope">
            <span>{{ scope.row.end_time | parseTime('{y}-{m}-{d}') }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="备注">
          <template slot-scope="scope">
            <span>{{ scope.row.remark}}</span>
          </template>
        </el-table-column>

      </el-table>
    </el-card>

    <pagination ref="pagination" :size.sync="query.limit" :offset.sync="query.offset" :total="total"  @updateList="getListByCompany"></pagination>

  </div>
</template>

<script>
  import {fetchBillingFileListReconcilatedByCompany} from '@/api/billing'
  import Pagination from '@/components/Pagination'
  import { parseTime } from '@/utils'
  import {formatCurrency } from '@/utils/misc'
  import BillingFileImportDialog from './billing-file-import'

  export default {
    name: "reconcilated-record-list",
    components: {
      Pagination
    },

    filters: {
      parsecurrency: function(value){
        return formatCurrency(value, 2)
      },
      parsereconciliationstatus: function(value) {
        let result
        switch(parseInt(value)){
          case -1:
            result = "错误"
            break
          case 0:
            result = "未对账"
            break
          case 1:
            result = "已对账"
            break
          case 2:
            result = "对账失败"
            break
          default:
            result = "未知"
        }
        return result
      },
      parseinvoicedstatus: function(value) {
        let result
        switch(parseInt(value)){
          case -1:
            result = "错误"
            break
          case 0:
            result = "未开发票"
            break
          case 1:
            result = "已开发票"
            break
          case 2:
            result = "开票失败"
            break
          default:
            result = "未知"
        }
        return result
      },
      parsepaidstatus: function(value) {
        let result
        switch(parseInt(value)){
          case -1:
            result = "错误"
            break
          case 0:
            result = "未收款"
            break
          case 1:
            result = "已收款"
            break
          case 2:
            result = "收款失败"
            break
          default:
            result = "未知"
        }
        return result
      }
    },

    data() {
      return {
        showView: false,
        showReceivable: false,
        showReceived: false,
        isShowImport: false,
        company_code: '',
        invoice_type: 0,
        searching: false,
        loading: false,
        loadingText: '正在加载数据，请稍等...',
        query: {
          search: '',
          offset: 0,
          limit: 20
        },
        total: 0,
        list: []
      }
    },

    methods: {
      getListByCompany() {
        this.loading = true
        fetchBillingFileListReconcilatedByCompany(this.query, this.company_code, this.invoice_type)
          .then(res => {
            this.list = res.results
            this.total = res.count
            this.loading = false
          })
          .catch(error => {
            this.loading = false
            this.$error_message(error)
          })
      },
      handleSearch() {
        // this.getListByCompany()
        this.$refs.pagination.backNumOne()
      },
      // 查看账单
      viewReconcilatedRecord(billing_file_id, billing_model) {
        this.$router.push({name: 'reconcilatedRecord', query: {billing_file_id: billing_file_id, billing_model: billing_model}})
      },
      //处理收入确认
      confirmIncome(id, billing_model, company_code, branch_office_code) {
        this.$router.push({
          name: 'receivableList',
          query: {
            company: this.company_code,
            billing_file_id: id,
            billing_model: billing_model,
            company_code:company_code,
            branch_office_code:branch_office_code
          }
        })
      },
      // 处理到账
      confirmCollected(id, billing_model){
        this.$router.push({
          name: 'receivedList',
          query: {
            company: this.company_code,
            billing_file_id: id,
            billing_model: billing_model
          }
        })
      },
      getStatusBadge(value) {
        let badge = 'badge-secondary'
        switch (parseInt(value)) {
          case -1:
            badge = 'badge-danger'
            break
          case 0:
            // badge = 'badge-info'
            badge = 'badge-warning'
            break
          case 1:
            badge = 'badge-success'
            break
          case 2:
            badge = 'badge-warning'
            break
          case 3:
            badge = 'badge-dark'
            break
          default:
            badge = 'badge-secondary'
        }
        return badge
      }
    },

    created() {
      // 入参检查
      if (this.$route.query.company_code === undefined){
        this.$router.push('/404')
      }
      this.company_code = this.$route.query.company_code

      // 不开票账单处理
      if (this.company_code === 'yihe') {
        this.invoice_type = 1
      }

      // 权限检查
      if (!(this.$perm(["billing.list_reconciled_billing_file"]) || this.$perm(["billing.list_receivable"]))) {
        this.$router.push('/401')
      }
      this.showView = true

      if (this.$perm(["billing.list_receivable"])) {
        this.showReceivable = true
      }

      if (this.$perm(["billing.list_received"])) {
        this.showReceived = true
      }

      this.getListByCompany()
    }
  }
</script>
